import { Title, NoMatchText, NoResultsWrapper } from './NoProductResults.styles';

const NoProductResults = () => {
  return (
    <NoResultsWrapper data-testid={'no-products-found'} key={'no-products-found'}>
      <Title>No products found</Title>
      <NoMatchText>Please ask the customer for their item's SKU.</NoMatchText>
      <NoMatchText>You may enter the partial (at least the first 4-digits) or the full SKU.</NoMatchText>
    </NoResultsWrapper>
  );
};

export default NoProductResults;
